<div class="list-contain list" *ngIf="show">
    <div class="item_container list">
        <ng-container *ngFor="let item of items; index as i">
            <div class="list_parent_item-new list">
                <app-card [item]="item" viewType="list"></app-card>
            </div>
            <ng-container *ngIf="bannerPosition[i] && banner?.id">
                <app-banner [banner]="banner" viewType="list"></app-banner>
            </ng-container>
        </ng-container>
    </div>
</div>
